module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_6-e71380898724c8dfe27949844f95f853.png";